// extracted by mini-css-extract-plugin
module.exports = {"container":"Empty_container__2Nzz-","icon":"Empty_icon__2i1sQ","desc":"Empty_desc__1fvcl"};